module.exports = "### Styles Overview\n\nThe styles have been divided into four sections. \n\n#### Brand guidelines\n\nTo deepen your understanding about the usage of brand related content check [Helsinki Brand Guidelines](/design/brandmaterial/) for brand reference.\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/styles/Overview/StylesOverview.md
// module id = 258
// module chunks = 0